<template>
  <vxe-table
    v-if="isLargeScreen"
    class="triggers-table"
    empty-text="No data"
    border="none"
    :data="triggerDataList"
    :span-method="mergeRowMethod"
  >
    <vxe-column
      field="triggerType"
      title="Trigger type"
      width="30%"
    ></vxe-column>
    <template
      v-if="alertTriggersType === TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT"
    >
      <vxe-column field="incident" title="Incident" width="70%"></vxe-column>
    </template>
    <template
      v-else-if="alertTriggersType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS"
    >
      <vxe-column
        field="bgpRouting"
        title="BGP routing"
        width="30%"
      ></vxe-column>
      <vxe-column
        field="originAS"
        title="Origin AS"
        width="40%"
        sortable
        sort-by="originAS"
      ></vxe-column>
    </template>
  </vxe-table>

  <div v-else class="mobile">
    <div class="icon-group-and-search">
      <div class="icon-group">
        <fa
          v-if="
            alertTriggersType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS &&
              processedTriggerDataList.length > 1
          "
          icon="sort-amount-down"
          class="icon"
          :class="{ active: isShowSortTool }"
          @click="toggleIsShowSortTool"
        ></fa>
      </div>
    </div>
    <div v-if="isShowSortTool" class="tool">
      <SortAndFilterToolAlertsRS
        :toolConfig="sortToolConfig"
        @onToolChange="handleSortToolChange"
      ></SortAndFilterToolAlertsRS>
    </div>
    <template v-if="alertTriggersType === TRIGGER_TYPE.BGP_ANNOUNCEMENT_STATUS">
      <div class="wrapper first">
        <span>Type</span>
        <span>BGP status</span>
      </div>
      <div class="wrapper">
        <span>BGP routing</span>
        <span>{{ processedTriggerDataList[0].bgpRouting }}</span>
      </div>
      <div class="wrapper last">
        <span>Origin AS</span>
        <template v-if="processedTriggerDataList.length === 1">
          <span>{{ processedTriggerDataList[0].originAS }}</span>
        </template>
        <template v-if="processedTriggerDataList.length > 1">
          <ul>
            <li
              v-for="(trigger, index) in processedTriggerDataList"
              :key="index"
            >
              {{ trigger.originAS }}
            </li>
          </ul>
        </template>
      </div>
    </template>
    <template
      v-else-if="
        alertTriggersType === TRIGGER_TYPE.ROA_OR_ROUTE_OBJECT_ALIGNMENT
      "
    >
      <div class="wrapper first">
        <span>Type</span>
        <span>ROA/Route object alignment</span>
      </div>
      <div class="wrapper last">
        <span>Incident</span>
        <span>{{ processedTriggerDataList[0].incident }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SortAndFilterToolAlertsRS from '../alertTableParts/SortAndFilterToolAlertsRS.vue';
import {
  TRIGGER_TYPE,
  TRIGGER_SORT_OPTION
} from '../../../../constants/alertsRoutingStatusConstant';

export default {
  name: 'AlertRSTriggersTable',
  components: { SortAndFilterToolAlertsRS },
  props: ['alertTriggersType', 'triggerDataList'],
  data() {
    return {
      TRIGGER_TYPE: TRIGGER_TYPE,
      isShowSortTool: false,
      sortType: 0,
      sortToolConfig: {
        placeholder: 'Sort',
        toolList: [
          { id: TRIGGER_SORT_OPTION.NONE, text: 'None' },
          {
            id: TRIGGER_SORT_OPTION.ORIGIN_AS_ASCENDING,
            text: 'Origin AS ascending'
          },
          {
            id: TRIGGER_SORT_OPTION.ORIGIN_AS_DESCENDING,
            text: 'Origin AS descending'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['isLargeScreen']),
    processedTriggerDataList() {
      let list = this.triggerDataList;

      // deep clone list as list.sort will change the origin list
      list = JSON.parse(JSON.stringify(list));

      switch (this.sortType) {
        case TRIGGER_SORT_OPTION.NONE:
          break;
        case TRIGGER_SORT_OPTION.ORIGIN_AS_DESCENDING:
          list.sort((a, b) => {
            const triggerA = a.originAS || '';
            const triggerB = b.originAS || '';
            if (triggerB < triggerA) return -1;
            if (triggerB > triggerA) return 1;

            return 0;
          });
          break;
        case TRIGGER_SORT_OPTION.ORIGIN_AS_ASCENDING:
          list.sort((a, b) => {
            const triggerA = a.originAS || '';
            const triggerB = b.originAS || '';
            if (triggerB < triggerA) return 1;
            if (triggerB > triggerA) return -1;

            return 0;
          });
          break;
        default:
          break;
      }

      return list;
    }
  },
  methods: {
    toggleIsShowSortTool() {
      this.isShowSortTool = !this.isShowSortTool;
      if (!this.isShowSortTool) this.sortType = TRIGGER_SORT_OPTION.NONE;
    },

    handleSortToolChange(val) {
      this.sortType = val;
    },

    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = ['bgpRouting', 'triggerType'];
      const cellValue = row[column.property];
      if (cellValue && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1];
        let nextRow = visibleData[_rowIndex + 1];
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.triggers-table {
  ::v-deep .vxe-header--row {
    background-color: #ffffff !important;
    background-image: none !important;
  }

  ::v-deep td.vxe-body--column {
    background-image: none;
    padding: 0.25rem 0;
  }

  ::v-deep .vxe-table--body {
    padding: 0.5rem 0;
  }

  ::v-deep td {
    vertical-align: top !important;
  }

  ::v-deep .vxe-cell {
    word-break: normal;
  }
}

.mobile {
  padding-bottom: 0.5rem;

  ul {
    list-style: none;
    margin: 0;
  }

  li {
    padding-bottom: 0.75rem;
    text-align: right;

    &:nth-last-child(1) {
      padding-bottom: 0;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    margin-top: 1rem;
    margin-bottom: 1.25rem;

    &.first {
      border-top: 1px solid #666;
      margin-top: 0.5rem;
      padding-top: 1rem;
    }
    &.last {
      border-bottom: 1px solid #666;
      padding-bottom: 1.5rem;
      margin-bottom: 1rem;
    }
  }

  .wrapper span:nth-child(1) {
    width: 6rem;
    min-width: 6rem;
    color: $text-black;
    font-weight: 600;
  }

  .wrapper span:nth-child(2) {
    text-align: left;
  }

  .icon-group-and-search {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    .icon {
      padding: 0.5rem;
      margin-right: 0.5rem;
      width: 2rem;
      height: 2rem;
      color: $icon-grey;
    }

    .active {
      color: $text-light-blue;
    }
  }

  .tool {
    padding-bottom: 0.5rem;
  }
}
</style>
